import React, { useState } from "react";
import PropTypes from "prop-types";
import Headline from "~/assets/js/components/Typography/Headline";
import i18n from "~/assets/js/Helpers/i18n";
import Tabs from "~/assets/js/components/Tabs";
import CurrentProduct from "./CurrentProduct";
import NutrientDressings from "./NutrientDressings";
import NutrientsPopup from "./NutrientsPopup";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import Button from "~/assets/js/components/Button";

export const nutrientNamesTranslations = {
    carbohydrate: i18n.t("nutrients.names.carbohydrate"),
    fat: i18n.t("nutrients.names.fat"),
    polyunsaturated_fatty_acid: i18n.t(
        "nutrients.names.polyunsaturatedFattyAcid"
    ),
    protein: i18n.t("nutrients.names.protein"),
    sugar: i18n.t("nutrients.names.sugar"),
    caloric_value: i18n.t("nutrients.names.caloricValue"),
};

const Nutrients = ({ product, isMainDish, isSauceProduct }) => {
    const { iconPath } = reactConfig;
    const { isDesktop } = useViewport();
    const [open, setOpen] = useState(false);

    const tabs = [
        {
            title: product.title,
            icon: <img src={`${iconPath}/salad.svg`} />,
            content: <CurrentProduct product={product} />,
        },
        {
            title: isSauceProduct
                ? i18n.t("ingredientCategories.sauces.name")
                : i18n.t("ingredientCategories.dressings.name"),
            icon: <img src={`${iconPath}/jar.svg`} />,
            content: <NutrientDressings isSauceProduct={isSauceProduct} />,
        },
    ];

    const renderTabs = isMainDish
        ? tabs
        : [{ content: <CurrentProduct product={product} /> }];
    return (
        <div className="nutrients">
            <Headline size={5} resizable>
                {i18n.t("nutrients.title")}
            </Headline>
            {isDesktop ? (
                <div>
                    <Tabs tabs={renderTabs} />
                </div>
            ) : (
                <>
                    <NutrientsPopup
                        open={open}
                        handleClose={() => {
                            setOpen(false);
                        }}
                        tabs={tabs}
                        isMainDish={isMainDish}
                        product={product}
                    />
                    <p className="additional-text">
                        {i18n.t("nutrients.mobile.text")}
                    </p>
                    <Button
                        onClick={() => {
                            setOpen(true);
                        }}
                        variant="secondary"
                        label={i18n.t("nutrients.mobile.open")}
                    />
                </>
            )}
        </div>
    );
};

const attributeType = {
    id: PropTypes.number,
    name: PropTypes.string,
    slug: PropTypes.string,
};

const productType = {
    attributes: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    content: PropTypes.string,
    image: PropTypes.string,
    intolerance: PropTypes.arrayOf(PropTypes.shape(attributeType)),
    priceGross: PropTypes.string,
    priceNet: PropTypes.string,
    taxRate: PropTypes.string,
    title: PropTypes.string,
};

Nutrients.propTypes = {
    product: PropTypes.shape(productType),
    isMainDish: PropTypes.bool,
};

export default Nutrients;
